module.exports = __webpack_public_path__ + "static/filmreel-34087fd8897b4ffaa3372d31b161ba60.gif";